var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatisticsItems(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.200195,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#E6F8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5404 20.8398C21.4137 20.8398 21.287 20.7931 21.187 20.6931L17.887 17.3931C17.6937 17.1998 17.6937 16.8798 17.887 16.6864C18.0804 16.4931 18.4004 16.4931 18.5937 16.6864L21.8937 19.9864C22.087 20.1798 22.087 20.4998 21.8937 20.6931C21.7937 20.7931 21.667 20.8398 21.5404 20.8398Z",
    fill: "#26B5ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.94 20.2864C14.4533 20.2864 13.9867 20.0931 13.6467 19.7464L10.82 16.9198C10.1067 16.2065 10.1067 15.0398 10.82 14.3264L15.5333 9.61313C16.2467 8.89979 17.4133 8.89979 18.1267 9.61313L20.9533 12.4398C21.3 12.7865 21.4933 13.2465 21.4933 13.7331C21.4933 14.2198 21.3 14.6865 20.9533 15.0265L16.24 19.7398C15.8933 20.0998 15.4333 20.2864 14.94 20.2864ZM16.8267 10.0798C16.6133 10.0798 16.4 10.1598 16.24 10.3264L11.5267 15.0398C11.2 15.3664 11.2 15.8931 11.5267 16.2198L14.3533 19.0465C14.6667 19.3598 15.2133 19.3598 15.5333 19.0465L20.2467 14.3331C20.4067 14.1731 20.4933 13.9664 20.4933 13.7464C20.4933 13.5264 20.4067 13.3131 20.2467 13.1598L17.42 10.3331C17.2533 10.1598 17.04 10.0798 16.8267 10.0798Z",
    fill: "#26B5ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5337 22.4998H9.53369C9.26036 22.4998 9.03369 22.2731 9.03369 21.9998C9.03369 21.7264 9.26036 21.4998 9.53369 21.4998H13.5337C13.807 21.4998 14.0337 21.7264 14.0337 21.9998C14.0337 22.2731 13.807 22.4998 13.5337 22.4998Z",
    fill: "#26B5ED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.287 18.4931C17.1604 18.4931 17.0337 18.4464 16.9337 18.3464L12.2204 13.6331C12.027 13.4397 12.027 13.1197 12.2204 12.9264C12.4137 12.7331 12.7337 12.7331 12.927 12.9264L17.6404 17.6397C17.8337 17.8331 17.8337 18.1531 17.6404 18.3464C17.547 18.4464 17.4137 18.4931 17.287 18.4931Z",
    fill: "#26B5ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticsItems);
export default __webpack_public_path__ + "static/media/statistics-items.06f1255ffeeaa81b7181119acbb24442.svg";
export { ForwardRef as ReactComponent };